import TextInput from "Components/molecule/inputs/text-input"
import CheckboxInput from "Components/molecule/inputs/checkbox-input"
import FormContainer from "Components/atoms/containers/form-container"
import PrimaryButton from "Components/atoms/buttons/primary-button"
import FormProps from "data/forms"
import ResetUserPasswordFields from "./types"

const PASSWORD_KEY = 'password'
const CONFIRM_PASSWORD_KEY = 'confirmPassword'
const SEND_EMAIL_KEY = 'sendEmail'

const ResetUserPasswordForm = ({
    values,
    handleChange,
    handleBlur,
    handleSubmit,
    errors,
    isValid,
    touched,
    isSubmitting
}: FormProps<ResetUserPasswordFields>) => {

    return <FormContainer
        inputs={<>
            <TextInput
                touched={!!touched.password}
                name={PASSWORD_KEY}
                key={PASSWORD_KEY}
                label={"New Password*"}
                placeholder={"Enter a new password"}
                type="password"
                value={values.password}
                onBlur={handleBlur}
                onChange={handleChange}
                error={!!errors.password && touched.password}
                message={touched.password ? errors.password : undefined}
            />
            <TextInput
                touched={!!touched.confirmPassword}
                name={CONFIRM_PASSWORD_KEY}
                key={CONFIRM_PASSWORD_KEY}
                label={"Confirm Password*"}
                placeholder={"Re-enter the new password"}
                type="password"
                value={values.confirmPassword}
                onBlur={handleBlur}
                onChange={handleChange}
                error={!!errors.confirmPassword && touched.confirmPassword}
                message={touched.confirmPassword ? errors.confirmPassword : undefined}
            />
            <CheckboxInput
                name={SEND_EMAIL_KEY}
                key={SEND_EMAIL_KEY}
                label={"Email the new password to the user"}
                checked={values.sendEmail}
                onChange={handleChange}
            />
        </>}
        buttons={
            <PrimaryButton
                type='submit'
                onClick={() => handleSubmit()}
                disabled={isSubmitting || !isValid}
                className="w-100"
            >
                {isSubmitting ? "Resetting...." : "Reset Password"}
            </PrimaryButton>
        }
    />
}

export default ResetUserPasswordForm
